import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getIsDarkTheme } from '../stores/theme/getters';

const ThemeSwitcher = () => {
  const isDarkTheme = useSelector(getIsDarkTheme) || false;
  const { pathname = '' } = window.location || {};

  useEffect(() => {
    const bodyContainer = document.querySelector('body');

    if (isDarkTheme) {
      bodyContainer.classList.add('theme--dark');
    } else {
      bodyContainer.classList.remove('theme--dark');
    }
  }, [isDarkTheme, pathname]);

  return '';
};

export default ThemeSwitcher;
